import React from 'react';
import { Section } from './ui/Section';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Carolina M.',
  context: '32 años, casada hace 5 años',
  quote: 'Llevaba meses sintiéndome ignorada. La primera noche que usé uno de los scripts, mi esposo me miró y dijo: "Nunca me lo habías explicado así." Lloré de alivio. Este ebook me devolvió la voz que sentía perdida.',
  highlight: 'Me devolvió la voz'
}, {
  name: 'Valentina R.',
  context: '28 años, en relación de 3 años',
  quote: 'Antes cada conversación importante terminaba en pelea o en silencio por días. Ahora tengo las palabras exactas para decir lo que siento sin que él se ponga a la defensiva. Nuestra relación cambió en una semana.',
  highlight: 'Cambió en una semana'
}, {
  name: 'Daniela P.',
  context: '37 años, madre de 2',
  quote: 'Pensé que era otra guía genérica de "comunícate mejor". Pero no. Son frases reales que puedes usar HOY. Copié un mensaje del bono de WhatsApp y por primera vez en meses tuvimos una conversación sin gritos.',
  highlight: 'Frases que funcionan HOY'
}, {
  name: 'Alejandra G.',
  context: '41 años, recién divorciada',
  quote: 'Ojalá hubiera tenido esto hace 10 años. Ahora lo uso para comunicarme mejor con mi ex por los niños y hasta con mi familia. Me siento segura de lo que digo por primera vez. Vale cada centavo.',
  highlight: 'Vale cada centavo'
}];
export function TestimonialsSection() {
  return <Section background="cream" data-id="element-192">
      <div className="text-center mb-12" data-id="element-193">
        <span className="text-rose-600 font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-194">
          Historias Reales
        </span>
        <h2 className="text-3xl font-bold text-gray-900" data-id="element-195">
          Mujeres que ya dieron el paso
        </h2>
        <p className="mt-4 text-gray-600 max-w-xl mx-auto" data-id="element-196">
          Ellas estaban exactamente donde tú estás ahora. Mira lo que cambió
          cuando encontraron las palabras correctas.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2" data-id="element-197">
        {testimonials.map((t, index) => <div key={index} className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100 flex flex-col" data-id="element-198">
            {/* Stars */}
            <div className="flex gap-0.5 mb-4" data-id="element-199">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-200" />)}
            </div>

            {/* Quote */}
            <div className="relative flex-grow mb-5" data-id="element-201">
              <Quote className="absolute -top-1 -left-1 h-6 w-6 text-rose-200 -z-0" data-id="element-202" />
              <p className="text-gray-700 leading-relaxed relative z-10 pl-4" data-id="element-203">
                {t.quote}
              </p>
            </div>

            {/* Highlight badge */}
            <div className="mb-4" data-id="element-204">
              <span className="inline-block bg-rose-50 text-rose-600 text-xs font-bold px-3 py-1 rounded-full" data-id="element-205">
                {t.highlight}
              </span>
            </div>

            {/* Author */}
            <div className="pt-4 border-t border-gray-100 flex items-center gap-3" data-id="element-206">
              <div className="h-10 w-10 rounded-full bg-gradient-to-br from-rose-300 to-pink-400 flex items-center justify-center text-white font-bold text-sm" data-id="element-207">
                {t.name.charAt(0)}
              </div>
              <div data-id="element-208">
                <p className="font-semibold text-gray-900 text-sm" data-id="element-209">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-210">{t.context}</p>
              </div>
            </div>
          </div>)}
      </div>

      <div className="mt-10 text-center" data-id="element-211">
        <p className="text-sm text-gray-400 italic" data-id="element-212">
          * Testimonios reales de clientas. Los resultados pueden variar según
          cada persona.
        </p>
      </div>
    </Section>;
}